import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch";
import {
    type MultipartUploadParams,
    type MultipartUploadResult,
    type UploadProgress,
    uploadFileMultipart as uploadFileMultipartUtil,
} from "@/utils/multipartUpload";
import { useCallback } from "react";

/**
 * Custom hook for multipart upload with authentication
 *
 * This is a thin wrapper around the multipartUpload utility that provides
 * authentication context from the useAuthenticatedFetch hook.
 */
export function useMultipartUpload() {
    const authenticatedFetch = useAuthenticatedFetch();

    const uploadFileMultipart = useCallback(
        async (
            file: File,
            params: MultipartUploadParams,
            onProgress?: (progress: UploadProgress) => void,
        ): Promise<MultipartUploadResult> => {
            return uploadFileMultipartUtil(file, params, onProgress, authenticatedFetch);
        },
        [authenticatedFetch],
    );

    return { uploadFileMultipart };
}

// Re-export types for convenience
export type { MultipartUploadParams, MultipartUploadResult, UploadProgress };
